import React from "react";
import "../../styles/components/profileView/profileCard.scss";

const ProfileCard = ({ name, image }) => {
  return (
    <div className="main-content">
      <div className="welcome-section">
        <div className="welcome-content">
          <div className="welcome-text">
            <h1>Welcome, {name || "User"}!</h1>
            <p>
              This is PIVOT, your personalized UPOU dashboard. Here you can
              quickly access UPOU's systems, stay up-to-date with UPOU news and
              events through the bulletin, and find other relevant information.
            </p>
          </div>
          <div className="profile-section">
            <div className="profile-picture">
              <img
                src={
                  image ||
                  "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png?20150327203541"
                }
                alt="Profile"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
